// apiDocsSchema.ts
import { authEndpoints } from "./groups/authEndpoints";
import { suprimentosEndpoints } from "./groups/suprimentosEndpoints";
import { recursoshumanosEndpoints } from "./groups/recursoshumanosEndpoints";
import { movimentationsEndpoints } from "./groups/movimentationsEndpoints";
import { standbyEndpoints } from "./groups/standbyEndpoints";
import { coordenacaoEndpoints } from "./groups/coordenacaoEndpoints";

export type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

export type ApiParamLocation = "path" | "query" | "header" | "body";

export type ApiParam = {
  name: string;
  in: ApiParamLocation;
  type: string;
  required?: boolean;
  description?: string;
  developed?: boolean;
  example?: any;
  source?: string;
};

export type ApiExample = {
  title: string;
  request?: any;
  response?: any;
};

export type ApiEndpoint = {
  group: string;
  name: string;
  method: HttpMethod;
  path: string;

  description?: string;
  authRequired?: boolean;
  developed?: boolean;

  /** Onde essa rota é usada (tela, fluxo, automação, etc.) */
  usageDescription?: string;

  /** Texto explicando o que vem na resposta (campos principais, contexto, etc.) */
  responseDetails?: string;

  params?: ApiParam[];

  playgroundDefaults?: {
    query?: Record<string, string>;
    body?: any;
  };

  examples?: ApiExample[];
};

export const apiEndpoints: ApiEndpoint[] = [
  ...authEndpoints,
  ...suprimentosEndpoints,
  ...recursoshumanosEndpoints,
  ...movimentationsEndpoints,
  ...coordenacaoEndpoints,
  ...standbyEndpoints,
];
